import { Button, DraggableWindowHeader } from "@hoylu/client-common";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { deleteTemplate } from "../../state/templates/templates.actions";
import { cancelDashboardOption } from "../../state/workspaces/workspaces.actions";
import { selectSelectedWorkspace } from "../../state/workspaces/workspaces.selector";
import { useI18n } from "../../utils/hooks/use.i18n";
import Styles from "./DeleteTemplateDialog.module.css";
import { Modal } from "./Modal";

export const DeleteTemplateDialog = () => {
  const dispatch = useDispatch();

  const t = useI18n("DELETE_TEMPLATE_DIALOG.");
  const tClose = useI18n("CLOSE_BUTTON.");

  const selectedWorkspace = useSelector(selectSelectedWorkspace);

  const cancelRemoveTemplate = () => dispatch(cancelDashboardOption());

  const removeTemplate = () => {
    if (!selectedWorkspace?.templateId) {
      return;
    }

    dispatch(
      deleteTemplate.request({
        templateId: selectedWorkspace.templateId,
        workspaceId: selectedWorkspace.workspaceId,
      }),
    );
    dispatch(cancelDashboardOption());
  };

  return (
    <Modal
      allowContentToOverflow={true}
      handleOutsideClick={cancelRemoveTemplate}
    >
      <div
        className={Styles.deleteTemplateDialog}
        data-test-id="linked-master-ws-dialog"
      >
        <DraggableWindowHeader
          close={tClose("CLOSE")}
          onClose={cancelRemoveTemplate}
          title={t("TITLE")}
        />
        <div className={Styles.subtitle}>
          <span>{t("SUBTITLE")}</span>
        </div>
        <div className={Styles.buttons}>
          <Button
            dataTestId={t("CANCEL")}
            onClick={cancelRemoveTemplate}
            type="secondary"
          >
            {t("CANCEL")}
          </Button>
          <Button
            dataTestId="delete-template"
            onClick={removeTemplate}
            type="primary"
          >
            {t("CONTINUE")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTemplateDialog;
